"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messagesConfig = {
  EN_US: {
    // Crew Status
    0: 'Scheduling Crew',
    1: 'Scheduling Crew',
    2: 'Crew Investigating',
    3: 'Crew Working',
    4: 'Additional Crews Required',
    5: 'Additional Crews Dispatched',
    6: 'Crews Working',
    9: 'N/A',
    // Cause
    '00': 'Under Investigation',
    '01': 'Planned Maintenance',
    '02': 'Planned Tree Trimming',
    '03': 'Equipment Problem',
    '04': 'Equipment Problem',
    '05': 'Equipment Problem',
    '06': 'Vehicle Accident',
    '07': 'Damaged Power Line(s)',
    '08': 'Damaged Power Line(s)',
    '09': 'Equipment Problem',
    10: 'Equipment Problem',
    11: 'Down Tree(s)',
    12: 'Flooding',
    13: 'Lightning',
    14: 'Severe Weather',
    // ETR
    'ETR-NULL': 'Pending Assessment',
    'ETR-EXP': 'Pending Assessment'
  }
};
var _default = messagesConfig;
exports.default = _default;